<template>
  <div>
    <h3 class="mb-5">Product Category</h3>
    <div class="h4 mb-5">
      編輯BU Page上各Categories封面圖，如需編輯Category資訊(如名稱、排序) 請至
      <a href="#" style="text-decoration: none; font-weight: bold;">
        Category
      </a>
      編輯
    </div>

    <div v-for="item in bu.product_category" :key="item.id">
      <div class="form-item pa-5"><h4>{{ item.name }}</h4></div>
      <div class="d-flex px-5 pt-5 mb-8">
        <div class="w-180px">
          <h4 class="mb-10px">Category Visual</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex justify-end flex-grow-1">
          <ImgUploader
            :imageUrl.sync="item.image"
            dir="category"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
};
</script>

<style></style>
